'use client';

import { createContext, useContext, ReactNode, useEffect, useState } from 'react';
import { SchoolConfig } from '@/types/config';
import { CopyProvider } from './CopyContext';

const ConfigContext = createContext<SchoolConfig | null>(null);

export function ConfigProvider({ config, children }: { config: SchoolConfig | null; children: ReactNode }) {
  return (
    <ConfigContext.Provider value={config}>
      <CopyProvider overrides={config?.copyOverrides}>{children}</CopyProvider>
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  return useContext(ConfigContext);
}

export function NoSSRConfigProvider({ config, children }: { config: SchoolConfig | null; children: ReactNode }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <ConfigProvider config={config}>{children}</ConfigProvider>;
}
